import { ApiBaseUrl, request } from "shared/clients/baseClient";

const setSurveyTags = (surveyId: string | number, tagIds: string[]) => {
  return request({
    options: {
      url: `${ApiBaseUrl}/survey/${surveyId}/tags/`,
      method: "POST",
      data: { tags: tagIds },
    },
  });
};

export const surveyTagsClient = {
  setSurveyTags,
};
